// BGP Details Data
import React from 'react';
import { GenericTableColumn } from '@ui-components/Table/GenericTable';
import { GenericTag } from '@ui-components/Tag/GenericTag';
import GenericButton from '@ui-components/Button/GenericButton';
import { ReactComponent as IconEdit } from '../../../../shared/assets/Icons/Icon_Edit.svg';
import { ReactComponent as IconDelete } from '../../../../shared/assets/Icons/Icon_Delete.svg';

export interface BgpNeighbor {
  neighborAddress: string;
  peerAs: string;
  interfaceAddress: string;
  localAs: string;
  operatingMode: 'Enterprise' | 'Telco';
  status: 'Active' | 'Inactive';
  
}

export const bgpNeighborsColumns: GenericTableColumn<BgpNeighbor>[] = [
  { header: 'Peer IP', accessor: 'neighborAddress' },
  { header: 'Peer ASN', accessor: 'peerAs' },
  { header: 'Local ASN', accessor: 'localAs' },
  {
    header: 'Mode',
    accessor: 'operatingMode',
    renderCell: (row) => {
      const mode = row.operatingMode?.toLowerCase() || '';
      const displayMode = mode === 'enterprise' ? 'Enterprise' : 'Telco';
      return (
        <GenericTag
          label={displayMode}
          variant={mode === 'enterprise' ? 'neutral' : 'warning'}
        />
      );
    },
  },
  {
    header: 'Status',
    accessor: 'status',
    renderCell: (row) => {
      const status = row.status?.toLowerCase() || '';
      const displayStatus = status.charAt(0).toUpperCase() + status.slice(1);
      return (
        <GenericTag
          label={displayStatus}
          variant={status === 'active' || status === 'established' ? 'success' : 'default'}
        />
      );
    },
  },
  {
    header: 'Actions',
    accessor: 'status',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        <GenericButton
          isIconOnly
          icon={<IconEdit className="w-8 h-8" />}
          variant="secondary"
          shape="filled"
          size="sm"
          aria-label="Edit"
          onClick={() => { console.log('Edit neighbor:', row); }}
        />
        <GenericButton
          isIconOnly
          icon={<IconDelete className="w-6 h-6" />}
          variant="danger"
          shape="filled"
          size="sm"
          aria-label="Delete"
          onClick={() => { console.log('Delete neighbor:', row); }}
        />
      </div>
    ),
  },
];

export const mockBgpNeighbors: BgpNeighbor[] = [
  {
    neighborAddress: '192.168.1.1',
    peerAs: '65001',
    interfaceAddress: '192.168.1.2',
    localAs: '65002',
    operatingMode: 'Enterprise',
    status: 'Active',
    
  },
  {
    neighborAddress: '10.0.0.1',
    peerAs: '65003',
    interfaceAddress: '10.0.0.2',
    localAs: '65002',
    operatingMode: 'Telco',
    status: 'Inactive',
    
  },
];
